// extracted by mini-css-extract-plugin
module.exports =  {"root":"X6iNs","selected":"UYCNb"};